import React from "react";
import { Box, Typography, Grid, Card } from "@mui/material";
import Table from "./Table";
import SideNavbar from "../../../components/sideNavbar";
import Header from "../../../components/header";

function CallLogs() {
  return (
    <Box
      sx={{
        height: "100%",
      }}
    >
      <Box
        sx={{
          ml: { xs: "0px", md: "280px" },
        }}
      >
        <SideNavbar />
        <Box
          sx={{
            display: {
              xs: "none",
              md: "initial",
            },
          }}
        >
          <Header
            title={"Call Logs"}
            paragraph={
              "The call recording typically appears after 5 minutes, though in some cases, it may take slightly longer."
            }
          />
        </Box>
        <Box component="main" sx={{ flexGrow: 1, p: 3 }}>
          <Box>
            <Table />
          </Box>
        </Box>
      </Box>
    </Box>
  );
}

export default CallLogs;
